export enum ECanStartTimeRecord {
  UNDEFINED,
  NO_WORKTIMESCHEM,
  BEFORE_WORKSTARTDATE,
  CAN_START,
}
